import React from "react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

// TODO: Design is still working on what this dialog should look like. We'll need to update this once we have the design.
export function ErrorDialog({ onClose }: { onClose: () => void }): JSX.Element {
  return (
    <>
      <DialogTitle>
        <FormattedMessage defaultMessage="Something went wrong" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage defaultMessage="We weren't able to complete your request. Please try again later." />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </DialogActions>
    </>
  )
}
